import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";

import { request } from "../request/request";

const initialState = {
    categories: [],
    loadingStatus: "idle",
    error: null
}

export const fetchSurveyFields = createAsyncThunk(
    'surveyFields/fetchSurveyFields',
    async ({token}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const response = await request(
                `${APP_URL}/surveys/create`,
                'GET',
                null,
                customHeaders
            )

            return response
        } catch (error) {
            rejectWithValue(error.status)
        }
    }
)

const surveyFieldsListSlice = createSlice({
    name: "surveyFields",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSurveyFields.pending, (state) => {
                state.categories = [];
                state.loadingStatus = "loading";
                state.error = null
            })
            .addCase(fetchSurveyFields.fulfilled, (state, action) => {
                state.categories = action.payload?.categories || [];
                state.loadingStatus = "idle";
                state.error = null;
            })
            .addCase(fetchSurveyFields.rejected, (state, action) => {
                state.categories = [];
                state.loadingStatus = "error";
                state.error = action.payload;
            })
    }
})

export default surveyFieldsListSlice.reducer;